export enum ViewMode {
  CARD_VIEW = 'cardView',
  LIST_VIEW = 'listView',
}
